import { AccessRights } from 'src/app/features/role/user-role/user-role'
import { UserAccessRightsGuard } from './../../role/user-role/user-access-rights.guard'
import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'

import { OperationInternalEventCreateComponent } from './create/show.component'
import { OperationInternalEventGeneralTabComponent } from './general-tab/show.component'
import { OperationInternalEventIndexComponent } from './index/index.component'
import { OperationInternalEventShowComponent } from './show/show.component'

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: OperationInternalEventIndexComponent,
    canActivate: [UserAccessRightsGuard],
    data: { accessRights: [AccessRights.OperationInternalEvents_read] }
  },
  {
    path: 'create',
    component: OperationInternalEventCreateComponent,
    canActivate: [UserAccessRightsGuard],
    data: { accessRights: [AccessRights.OperationInternalEvents_write] }
  },
  {
    path: ':operationInternalEventId',
    component: OperationInternalEventShowComponent,
    canActivate: [UserAccessRightsGuard],
    data: { accessRights: [AccessRights.OperationInternalEvents_read] },
    children: [
      {
        path: '',
        component: OperationInternalEventGeneralTabComponent
      }
    ]
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OperationInternalEventRoutingModule {}
